<template>
    <b-modal
        id="modal-bakselector"
        size="xl"
        ref="modal"
        :title="formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
    >
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>
        <b-row>
            <b-col sm="8">
                <period-selector
                    id="selector-production"
                    v-model="selectDays"
                    v-bind:periodDays="periodeDagen"
                    @change="setNewDates"
                />
            </b-col>
            <b-col sm="2">
                <b-col sm="11">
                    <b-button @click="loadData()" class="bgc_aux_normal"
                        ><font-awesome-icon
                            icon="arrow-down"
                            size="1x"
                        />&nbsp;{{ $t('com_show', { ns: 'common' }) }}
                    </b-button>
                </b-col>
                <b-col sm="1"> </b-col>
            </b-col>
        </b-row>
        <b-table
            :items="prodinfoLijst"
            :fields="visibleFields"
            stacked="md"
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            selectable
            :select-mode="'single'"
            striped
            @row-selected="set_input"
        />
    </b-modal>
</template>
<script>
import { loadList, loadItem } from '../../models/DataHelper';
import DateHelper from '../../models/DateHelper';
import PeriodSelector from '../components/PeriodSelector.vue';

export default {
    name: 'BakSelector',
    data: function () {
        return {
            selectDays: null,
            van: null,
            tot: null,
            dag: 'day',
            periodeDagen: 1,
            showDismissibleAlert: false,
            alertText: '',
            isDagInfo: true,
            prodinfoLijst: [],
            formtitle: '',
            selectedBakID: -1
        };
    },
    model: {
        prop: 'visible',
        event: 'changed'
    },
    props: {
        datum: {},
        inputBakID: {
            type: Number,
            default: -1
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: { PeriodSelector },
    computed: {
        visibleFields() {
            const fieldsInit = [
                { key: 'id', label: 'Id', sortable: false, visible: true },
                {
                    key: 'productieDatum',
                    label: this.$t('com_datum', { ns: 'common' }),
                    sortable: false,
                    visible: true
                },
                { key: 'bakno', label: '#', sortable: false, visible: true },
                {
                    key: 'bakgroepInternID',
                    label: 'BG#',
                    sortable: false,
                    visible: true
                },
                {
                    key: 'kaasnaam',
                    label: this.$t('com_kaassoort', { ns: 'common' }),
                    sortable: false,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {            
            this.$emit('input', this.selectedBakID);
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-bakselector');
            });
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) this.loadData();
        },
        async loadData() {
            if (this.isDagInfo) {
                const selectionData = {
                    bookdate: DateHelper.localDateToUTC(this.van)
                };
                this.prodinfoLijst = await loadList(
                    'production/getBatchInfoLijst',
                    'production/loadBatchInfo',
                    selectionData,
                    true,
                    this.$t
                );
            } else {
                const selectionData = {
                    from: DateHelper.localDateToUTC(this.van),
                    until: DateHelper.localDateToUTC(this.tot)
                };
                this.prodinfoLijst = await loadList(
                    'production/getBatchInfoHistLijst',
                    'production/loadBatchInfoOverPeriod',
                    selectionData,
                    true,
                    this.$t
                );
            }
            this.totalRows = this.prodinfoLijst ? this.prodinfoLijst.length : 0;
        },
        set_input(row) {
            if (row != null ) {
                this.selectedBakID = row[0].id;
            }
        }
    },
    mounted() {},
    async created() {
        this.selectedBakID = this.inputBakID;
        this.van =
            this.datum != undefined
                ? this.datum
                : new Date().toISOString().split('T')[0];
        this.tot = this.van;
        await this.loadData();
    }
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>

